<template>
  <button
    class="transition-colors outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-main-lighter"
    :class="auth.user ? 'pointer-events-none select-none' : ''"
    aria-label="Toggle dark mode"
    @click="!auth.user && toggleDarkMode()"
  >
    <div class="flex items-center justify-center w-5 h-5">
      <Icon v-if="!isDarkMode" :outerClass="!auth.user ? 'stroke-theme-secondary' : '' " type="theme-light"  />
      <Icon v-else type="theme-dark"  />
    </div>
  </button>
</template>

<script>
import Icon from '@/Icons/OptimizedIcons.vue'
import { applyTheme, isSavedThemeDark } from '@/Composables/useTheme.js'
export default {
  name: 'ThemeSwitcher',
  components: {
    Icon
  },
  emits: ['theme-change'],
  data() {
    return {
		auth: this.$page.props.auth,
      isDarkMode: false,
    };
  },
  mounted() {
    this.isDarkMode = isSavedThemeDark();
    this.$emit('theme-change', this.isDarkMode);
  },
  methods: {
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      applyTheme(this.isDarkMode);
      this.$emit('theme-change', this.isDarkMode);
    },
  },
};
</script>
